import type { TFunction } from 'i18next';

/**
 * Scopes come off the API as `<resource>.<action>` strings (AVAILABLE_SCOPES in
 * the backend app registry). Translating the two halves separately means a new
 * backend scope still renders readable text instead of falling back to the raw
 * `paylinks.write` slug, and we only add a word when a new resource appears.
 */
export function scopeLabel(scope: string, t: TFunction): string {
  const [resource, action] = scope.split('.');
  const resourceLabel = t(`apps.scopeResources.${resource}`, resource);
  if (!action) return resourceLabel;
  const actionLabel = t(`apps.scopeActions.${action}`, action);
  return `${resourceLabel}: ${actionLabel}`;
}

/** App store categories are free text on the backend, so unknown ones pass through. */
export function categoryLabel(category: string, t: TFunction): string {
  return t(`apps.categories.${category}`, category);
}
